import React, { useEffect, useState } from 'react';

const BASE_WIDTH = 1747;
const BASE_HEIGHT = 650;
const MOBILE_WIDTH = 370;
const MOBILE_HEIGHT = 1015;
const MOBILE_BREAKPOINT = 768;

const heroGradient =
  'linear-gradient(to bottom, rgba(255, 246, 236, 0), #EFEEF3 40%, #E5E3E7 77%, #D7CAC8 100%)';

const ImageFlowBoard = () => {
  const [scale, setScale] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const fullText = 'medieval man';
  const [typedText, setTypedText] = useState('');
  const [showImage, setShowImage] = useState(false);
  const [pipelineReady, setPipelineReady] = useState(false);
  const [finalReady, setFinalReady] = useState(false);




  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      setTypedText(fullText.slice(0, index + 1));
      index++;

      if (index === fullText.length) {
        clearInterval(interval);

        setTimeout(() => {
          setShowImage(true);
          setFinalReady(true);
          setPipelineReady(true);
        }, 300);
      }
    }, 80);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const checkMobile = vw <= MOBILE_BREAKPOINT;
      setIsMobile(checkMobile);

      if (checkMobile) {
        // MOBILE SCALING: Scale 370px to fit the screen width
        const mobileScale = vw / MOBILE_WIDTH;
        // We use 0.95 to keep a tiny bit of margin on the sides
        setScale(mobileScale * 0.95);
      } else {
        // DESKTOP SCALING: Scale 1747px to fit the screen
        const scaleX = vw / BASE_WIDTH;
        const scaleY = vh / BASE_HEIGHT;
        setScale(Math.min(scaleX, scaleY) * 0.95);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    const blocks = document.querySelectorAll('[data-animate]');

    if (!blocks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const order = Number(entry.target.dataset.order || 0);

            //Gate 1: only SEARCH allowed initially
            if (!pipelineReady && order !== 0) {
              return;
            }

            //Gate 2: FINAL RESULT waits for prompt completion
            if (order === 10 && !finalReady) {
              return;
            }

            setTimeout(() => {
              entry.target.classList.add('is-visible');
            }, order * 50);

            observer.unobserve(entry.target);
          }

        });
      },
      { threshold: 0.2 }
    );

    blocks.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [isMobile, pipelineReady, finalReady]);

  // Calculate the "Visual Height" so the container doesn't cut off top/bottom
  const activeHeight = isMobile ? MOBILE_HEIGHT : BASE_HEIGHT;
  const scaledContainerHeight = activeHeight * scale;

  return (
    <div
      style={{
        backgroundColor: '#ededed',
        width: '100%',
        height: `${scaledContainerHeight}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        position: 'relative',
        marginTop: isMobile ? '0' : '-60px', // Adjust these values for overlap amount
        zIndex: 2,
      }}
    >
      <style>{`
      .fade-block {
        opacity: 0;
        transform: translateY(12px);
        transition:
          opacity 0.8s ease-out,
          transform 0.8s ease-out;
        will-change: opacity, transform;
      }

      .fade-block.is-visible {
        opacity: 1;
        transform: translateY(0);
      }
    `}</style>
      <div
        style={{
          width: isMobile ? `${MOBILE_WIDTH}px` : `${BASE_WIDTH}px`,
          height: isMobile ? `${MOBILE_HEIGHT}px` : `${BASE_HEIGHT}px`,
          transform: `scale(${scale})`,
          transformOrigin: 'center center',
          flexShrink: 0,
          position: 'absolute',
        }}
      >
        {isMobile ? <MobileBoard typedText={typedText} showImage={showImage}/> : <DesktopBoard typedText={typedText} showImage={showImage}/>}
      </div>
    </div>
  );
};

/// =============
/// DESKTOP BOARD
/// =============
const DesktopBoard = ({ typedText, showImage}) => {
  return (
    <div
      style={{
        background: heroGradient,
        width: '100%',
        height: '100%',
        borderRadius: '24px',
        position: 'relative',
        fontSize: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        data-animate
        data-order="0"
        className="fade-block"
        style={{ position: 'absolute', left: '58px', top: '5px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>SEARCH REFERENCE DATABASE</div>
        <div style={{ backgroundColor: 'rgba(225,225,225,0.4)', padding: '10px', borderRadius: '16px', width: '263px', height: '210px' }}>
          <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', borderRadius: '6px', padding: '4px 10px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
            <img src="./images/Search.svg" alt="" style={{ width: '13px', marginRight: '6px' }} />
            <span style={{ fontFamily: 'ZTNatureLi', fontSize: '12px' }}>{typedText}<span style={{ opacity: 0.6 }}>|</span></span>
          </div>
          <img src="./images/man31.webp" alt="" style={{ width: '245px', height: '156px', borderRadius: '8px', objectFit: 'cover', opacity: showImage ? 1 : 0, transform: showImage ? 'scale(1)' : 'scale(0.96)', transition: 'opacity 0.6s ease, transform 0.6s ease', }} />
        </div>
        <img
          data-animate
          data-order="1"
          className="fade-block"
          src="./images/line1.svg" alt="" style={{ position: 'absolute', left: '130px' }} />
      </div>

      <div
        data-animate
        data-order="2"
        className="fade-block"
        style={{ position: 'absolute', left: '122px', top: '469px', zIndex: 2 }}>
        <img
          data-animate
          data-order="3"
          className="fade-block"
          src="./images/line2.svg" alt="" style={{ position: 'absolute', left: '90px', bottom: '65px' }} />
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>COLOR REF</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '10px', borderRadius: '16px', width: '277px' }}>
          <img src="./images/color.svg" alt="" style={{ width: '100%', borderRadius: '8px' }} />
        </div>
      </div>

      <div
        data-animate
        data-order="4"
        className="fade-block"
        style={{ position: 'absolute', left: '456px', top: '160px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>TREATED IMAGE</div>
        <div style={{ backgroundColor: 'rgba(254,254,254,0.4)', padding: '10px', borderRadius: '16px', width: '334px', height: '439px' }}>
          <img src="./images/man4.webp" alt="" style={{ width: '316px', height: '421px', borderRadius: '8px', objectFit: 'cover' }} />
        </div>
        <img
          data-animate
          data-order="5"
          className="fade-block"
          src="./images/line4N.svg" alt="" style={{ position: 'absolute', left: '335px', bottom: '145px' }} />
      </div>

      <div
        data-animate
        data-order="6"
        className="fade-block"
        style={{ position: 'absolute', right: '643px', top: '129px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>REF ELEMENT</div>
        <div style={{ backgroundColor: 'rgba(255,255,255,0.4)', padding: '10px', borderRadius: '16px', width: '197px', height: '197px' }}>
          <img src="./images/pizza1.webp" alt="" style={{ width: '179px', height: '179px', borderRadius: '8px' }} />
        </div>
        <img
          data-animate
          data-order="7"
          className="fade-block"
          src="./images/line5N.svg" alt="" style={{ position: 'absolute', left: '75px' }} />
      </div>

      <div
        data-animate
        data-order="8"
        className="fade-block"
        style={{ position: 'absolute', right: '518px', bottom: '110px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>PROMPT</div>
        <div style={{ backgroundColor: 'rgba(255,255,255,0.4)', padding: '10px', borderRadius: '16px', width: '147px' }}>
          <div style={{ backgroundColor: 'rgba(103,99,134,0.4)', padding: '10px', borderRadius: '12px', fontFamily: 'ZTNatureLi', fontSize: '12px', color: '#fff' }}>Man is sitting and eating pizza from a box</div>
        </div>
        <img
          data-animate
          data-order="9"
          className="fade-block"
          src="./images/line6.svg" alt="" style={{ position: 'absolute', left: '148px', bottom: '18px' }} />
      </div>

      <div
        data-animate
        data-order="10"
        className="fade-block"
        style={{ position: 'absolute', right: '93px', top: '96px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>READY FOR BRIEF</div>
        <div style={{ backgroundColor: 'rgba(254,254,254,0.4)', padding: '10px', borderRadius: '16px', width: '334px', height: '502px' }}>
          <img
            data-animate
            data-order="11"
            className="fade-block"
            src="./images/pizzaman2.webp" alt="" style={{ width: '316px', height: '484px', borderRadius: '8px' }} />
        </div>
      </div>
    </div>
  );
};


/// ============
/// MOBILE BOARD
/// ============
const MobileBoard = ({ typedText, showImage}) => {
  return (
    <div
      style={{
        background: heroGradient,
        width: '370px',
        height: '1015px',
        borderRadius: '16px',
        position: 'relative',
        overflow: 'hidden',
        fontSize: '10px',
      }}
    >
      <div
        data-animate
        data-order="0"
        className="fade-block"
        style={{ position: 'absolute', left: '13px', top: '10px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>SEARCH REFERENCE DATABASE</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '10px', borderRadius: '14px', width: '170px', height: "161px" }}>
          <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', borderRadius: '6px', padding: '5px 10px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
            <img src="./images/Search.svg" alt="" style={{ width: '12px', marginRight: '6px' }} />
            <span style={{ fontFamily: 'ZTNatureLi', fontSize: '10px' }}>{typedText}<span style={{ opacity: 0.6 }}>|</span></span>
          </div>
          <img src="./images/man3.webp" alt="" style={{ width: '150px', height: '105px', borderRadius: '8px', objectFit: 'cover', opacity: showImage ? 1 : 0, transform: showImage ? 'scale(1)' : 'scale(0.96)', transition: 'opacity 0.6s ease, transform 0.6s ease', }} />
        </div>
        <img src="./images/line11.svg" alt=""
          data-animate
          data-order="1"
          className="fade-block"
          style={{ position: 'absolute', left: '50px', top: '178px' }} />
      </div>

      <div
        data-animate
        data-order="2"
        className="fade-block"
        style={{ position: 'absolute', right: '0px', top: '165px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>COLOR REF</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '9px', borderRadius: '14px', width: '173px', height: "45px" }}>
          <img src="./images/color.svg" alt="" style={{ width: '155px', height: "27px", borderRadius: '8px' }} />
        </div>
        <img src="./images/line22.svg" alt=""
          data-animate
          data-order="3"
          className="fade-block"
          style={{ position: 'absolute', right: '173px', top: '38px' }} />
      </div>

      <div
        data-animate
        data-order="4"
        className="fade-block"
        style={{ position: 'absolute', left: '16px', top: '238px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>TREATED IMAGE</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '9px', borderRadius: '16px', width: '254px', height: '169px' }}>
          <img src="./images/man02.webp" alt="" style={{ width: '236px', height: '151px', borderRadius: '8px', objectFit: 'cover' }} />
        </div>
        <img src="./images/line33.svg" alt=""
          data-animate
          data-order="5"
          className="fade-block"
          style={{ position: 'absolute', left: '90px', top: '185px' }} />
      </div>

      <div
        data-animate
        data-order="6"
        className="fade-block"
        style={{ position: 'absolute', right: '25px', top: '440px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>REF ELEMENT</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '9px', borderRadius: '14px', width: '168px', height: '168px' }}>
          <img src="./images/pizza1.webp" alt="" style={{ width: '150px', height: '150px', borderRadius: '8px', objectFit: 'cover' }} />
        </div>
        <img src="./images/line44.svg" alt=""
          data-animate
          data-order="7"
          className="fade-block"
          style={{ position: 'absolute', left: '-45px', top: '115px' }} />
      </div>

      <div
        data-animate
        data-order="8"
        className="fade-block"
        style={{ position: 'absolute', left: '30px', top: '649px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>PROMPT</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '9px', borderRadius: '8px', width: '199px', height: "54px" }}>
          <div style={{ backgroundColor: 'rgba(103,99,134,0.4)', paddingTop: '3px', paddingLeft: "25px",paddingRight:"10px", borderRadius: '8px', fontFamily: 'ZTNatureLi', fontSize: '10px', color: '#fff', width: "179px", height: "35px" }}>Man is sitting and eating pizza from a box</div>
        </div>
        <img src="./images/line55.svg" alt=""
          data-animate
          data-order="9"
          className="fade-block"
          style={{ position: 'absolute', left: '73px', top: '73px' }} />
      </div>

      <div
        data-animate
        data-order="10"
        className="fade-block"
        style={{ position: 'absolute', right: '16px', bottom: '20px', zIndex: 2 }}>
        <div style={{ marginBottom: '4px', fontFamily: 'ZTNatureMed' }}>READY FOR BRIEF</div>
        <div style={{ backgroundColor: 'rgba(250,250,250,0.4)', padding: '9px', borderRadius: '16px', width: '337px', height: '222px' }}>
          <img src="./images/man01.webp" alt=""
            data-animate
            data-order="11"
            className="fade-block"
            style={{ width: '320px', height: '204px', borderRadius: '8px', objectFit: 'cover' }} />
        </div>
      </div>
    </div>
  );
};

export default ImageFlowBoard;